import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=09f7ce1a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09f7ce1a')) {
      api.createRecord('09f7ce1a', component.options)
    } else {
      api.reload('09f7ce1a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=09f7ce1a&", function () {
      api.rerender('09f7ce1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uJIXrWpzu1S5/JS/comp/ImgFallback.vue"
export default component.exports